import callApi from '../../util/apiCaller';
import { capitalizeFirstLetter } from '../../util/text';

import { getApplicantId, getApplicantSessionId } from '../Applicant/ApplicantActions';
import { addMessageRequest } from '../Conversation/ConversationActions';
import { FETCH_LIMIT, getItemsRequest, sendSocket } from '../App/AppActions';

// Export Constants
export const SET_SESSION_FLAGS = 'SET_SESSION_FLAGS';
export const SET_APPLICANT_FLAGS = 'SET_APPLICANT_FLAGS';

export const FLAG_STATUS_PENDING = 'pending';
export const FLAG_STATUS_VERIFIED = 'verified';
export const FLAG_STATUS_INEXACT = 'inexact';

// Export Actions
export function getSessionFlagsRequest(sessionId) {
	return dispatch => dispatch(getItemsRequest(`session/${sessionId}/flags`, 'flags', items => dispatch(setSessionFlags(sessionId, items || [])), { pager: { size: FETCH_LIMIT * 2 } }, { isRecursive: true }));

	// return dispatch => {
	//     return callApi(`session/${sessionId}/flags`).then(res => {
	//         if(res.flags) {
	//             dispatch(setSessionFlags(sessionId, res.flags));
	//         }
	//         return res.flags;
	//     }).catch(error => {
	//         return null;
	//     });
	// };
}

export function getApplicantFlagsRequest(sessionId, applicantId) {
	return dispatch => {
		return callApi(`applicant/${applicantId}/flags`).then(res => {
			if(res.flags) {
				dispatch(setApplicantFlags(sessionId, applicantId, res.flags));
			}
			return res.flags;
		}).catch(error => {
			return null;
		});
	};
}

export function editFlagRequest(sessionId, flag, conversationId = null, fetchAll = false, addMessage = true, escapeDeduplication = false) {
	return dispatch => {
		return callApi('flag/edit', 'post', { flag, escapeDeduplication }).then(res => {
			if(res.flag) {
				fetchAll && dispatch(getApplicantFlagsRequest(sessionId, flag.applicant));

				!flag._id && res.flag._id && conversationId && addMessage && dispatch(addMessageRequest({
					conversation: conversationId,
					text: `flagAddedCode${capitalizeFirstLetter(flag.code)}`,
					type: 'system',
					hideToRoles: ['student'],
				}));
				dispatch(sendSocket({ type: 'applicant/flag/update', data: { session: sessionId, applicant: getFlagApplicantId(res.flag) } }));
			}
			return res.flag;
		}).catch(error => {
			return null;
		});
	};
}

export function removeFlagRequest(sessionId, flag) {
	return dispatch => {
		return callApi('flag/remove', 'delete', { flag }).then(res => {
			if(res.ok) {
				dispatch(getApplicantFlagsRequest(sessionId, flag.applicant));
				dispatch(sendSocket({ type: 'applicant/flag/update', data: { session: sessionId, applicant: getFlagApplicantId(flag) } }));
			}
			return res.ok;
		}).catch(error => {
			return null;
		});
	};
}

// Getters
export function getSessionFlags(store, sessionId) {
	const sessionFlagsData = store.flags.data.find(sessionFlagsData => sessionFlagsData.session === sessionId);
	if(sessionFlagsData) {
		return sessionFlagsData.flags || [];
	}
	return [];
}

export function getApplicantFlags(store, sessionId, applicantId) {
	return getSessionFlags(store, sessionId).filter(sessionFlag => getFlagApplicantId(sessionFlag) === applicantId);
}

export function getAnswerRelatedFlags(store, applicant, answer) {
	return (
		answer
			? getApplicantFlags(store, getApplicantSessionId(applicant), getApplicantId(applicant)).filter(flag => {
				return flag && ((flag.data || {}).copyCheatQuestions || []).find(copyCheat => copyCheat._id.toString() === answer.question.toString());
			})
			: []
	);
}

export function getFlagApplicantId(flag) {
	return flag ? ((flag.applicant && flag.applicant._id) || flag.applicant) : null;
}

export function getFlagAuthorId(flag) {
	return flag ? ((flag.author && flag.author._id) || flag.author) : null;
}

export function getFlagTypes() {
	return ['success', 'warning', 'danger', 'info'];
}

export function getFlagCodes() {
	return ['cheat', 'identity', 'audio', 'application', 'environment', 'network', 'other'];
}

export function getFlagStatuses() {
	return [FLAG_STATUS_PENDING, FLAG_STATUS_INEXACT, FLAG_STATUS_VERIFIED];
}

export function getFlagStatusColor(flag) {
	switch(flag.status) {
	case FLAG_STATUS_VERIFIED:
		return 'success';

	case FLAG_STATUS_INEXACT:
		return 'secondary';

	default:
		return 'warning';
	}
}

export function getFlagCodeIcon(flag) {
	switch(flag.code) {
	case 'cheat':
		return 'copy';

	case 'identity':
		return 'id-card';

	case 'audio':
		return 'volume-up';

	case 'application':
		return 'window-restore';

	case 'environment':
		return 'desktop';

	case 'network':
		return 'wifi';

	case 'other':
	default:
		return '';
	}
}

// Actions

export function setSessionFlags(sessionId, flags) {
	return {
		type: SET_SESSION_FLAGS,
		sessionId,
		flags,
	};
}

export function setApplicantFlags(sessionId, applicantId, flags) {
	return {
		type: SET_APPLICANT_FLAGS,
		sessionId,
		applicantId,
		flags,
	};
}
